import { environment } from '../../environments/environment';

const BASE_API = `${environment.apiUrl}/api`;
const BASE_API_WITHOUT_SLASH_API = `${environment.apiUrl}`;

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${BASE_API_WITHOUT_SLASH_API}/oauth2/login-credentials/`,
    ME: `${BASE_API_WITHOUT_SLASH_API}/oauth2/me/`,
    REFRESH_TOKEN: `${BASE_API_WITHOUT_SLASH_API}/oauth2/token/refresh/`,
    SSO_LOGIN: `${BASE_API_WITHOUT_SLASH_API}/oauth2/exchange-azure-token/`
  },
  TENANTS: {
    LIST: `${BASE_API}/tenants/`,
    AZURE_AD: (tenantUid: string) => `${BASE_API}/tenants/${tenantUid}/azure-ad/`
  },
  TENANT_SERVICES: {
    LIST: `${BASE_API}/tenant-services/`,
    DETAIL: (id: number | string) => `${BASE_API}/tenant-services/${id}/`
  },
  USERS: {
    LIST_WITH_SERVICES: `${BASE_API}/users-with-services/`,
    CREATE: `${BASE_API}/users/`,
    DETAIL: (username: string) => `${BASE_API}/users/${username}/`
  },
  USER_SERVICE_MANAGEMENT: {
    LIST: `${BASE_API}/user-service-management/`,
    DETAIL: (id: number | string) => `${BASE_API}/user-service-management/${id}/`
  },
  TENANT_SERVICE_DB: {
    CONFIG: (tenantUid: string) => `${BASE_API_WITHOUT_SLASH_API}/api/v3/tenant/service/db-config/${tenantUid}/`,
    MSSQL: (tenantUid: string) => `${BASE_API_WITHOUT_SLASH_API}/api/v3/tenant/service/db/${tenantUid}/`,
    SNOWFLAKE: (tenantUid: string) => `${BASE_API_WITHOUT_SLASH_API}/api/v3/tenant/service/db/snowflake/${tenantUid}/`,
    DATABRICKS: (tenantUid: string) => `${BASE_API_WITHOUT_SLASH_API}/api/v3/tenant/service/db/databricks/${tenantUid}/`,
    MDM: {
      LIST: `${BASE_API}/service/mdm-db-configs/`,
      DETAIL: (tenantUid: string) => `${BASE_API}/service/mdm-db-configs/${tenantUid}/`
    }
  },
  TENANT_ROLES: {
    ROLES: {
      LIST: `${BASE_API}/v3/acl/roles/`,
      DETAIL: (id: number | string) => `${BASE_API}/v3/acl/roles/${id}/`
    },
    PAGES: {
      LIST: `${BASE_API}/pages/`
    },
    PAGE_ASSIGNMENTS: {
      LIST: `${BASE_API}/role-page-assignments/`,
      BULK_CREATE: `${BASE_API}/role-page-assignments/bulk-create/`
    },
    PERMISSIONS: {
      BULK_CREATE: `${BASE_API}/v3/acl/permissions/bulk-create/`
    },
    CONTAINERS: {
      LIST: (tenantUid: string) => `${BASE_API}/blob/service/containers/${tenantUid}/`
    },
    TABLES_COLUMNS: {
      LIST: (tenantUid: string) => `${BASE_API}/v3/database/service/tables-columns/${tenantUid}/`
    },
    DCR_TYPES: {
      LIST: (tenantUid: string) => `${BASE_API}/service/tenants/${tenantUid}/dcr-types/`
    }
  }
};
